import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectShowDetail } from 'store/Manage/selectors';
import Title from '../Title';
import {
  Wrapper,
  CloseIconWrapper,
  CloseIcon
} from './styled';

const Header = ({ onClose }) => {
  const show = useSelector(selectShowDetail);

  if (!show) return null;
  return (
    <Wrapper>
      <Title />
      <CloseIconWrapper onClick={ onClose }>
        <CloseIcon />
      </CloseIconWrapper>
    </Wrapper>
  );
};

Header.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default Header;
